import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wallet-input" }

import { computed, ref, type PropType } from 'vue';
import { inject } from 'vue';

import BigNumber from '@exchange/helpers/bignumber';
import { BalanceModel } from '@exchange/libs/balances/service/src';
import { type ModalVariant } from '@exchange/libs/modals/src';
import { type CurrencyModel } from '@exchange/libs/utils/currency/src';

import LockedFunds from './LockedFunds.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WalletInput',
  props: {
  balance: { type: Object as PropType<BalanceModel>, required: true },
  currency: { type: Object as PropType<CurrencyModel>, required: true },
  disabled: { type: Boolean, default: true },
  precision: { type: [String, Number], required: true },
  showTotal: { type: Boolean, default: false },
  translationBaseKey: { type: String, required: true },
  variant: { type: String as PropType<ModalVariant>, required: true },
},
  setup(__props) {

const props = __props;

const balanceMasked = inject('balanceMasked', ref(false));

const lockedBalance = computed(() => Number(props.balance.locked).toFixed(Number(props.precision)));
const hasLockedFunds = computed(() => props.balance.locked.gt(0));

const balanceValue = computed(() => {
  const available = new BigNumber(props.balance.available);

  if (props.showTotal) {
    return available.plus(props.balance.locked);
  }

  return available;
});

return (_ctx: any,_cache: any) => {
  const _component_ot_balance = _resolveComponent("ot-balance")!
  const _component_x_input_text = _resolveComponent("x-input-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_x_input_text, {
      class: "wallet-input__input",
      disabled: __props.disabled,
      variant: __props.variant === 'light' ? 'light' : 'dark',
      value: _ctx.$t(`${__props.translationBaseKey}.value`, { currency: __props.currency.symbol }),
      label: _ctx.$t(`${__props.translationBaseKey}.label`)
    }, {
      right: _withCtx(() => [
        _createVNode(_component_ot_balance, {
          masked: _unref(balanceMasked),
          precision: __props.precision,
          symbol: __props.currency.symbol,
          value: balanceValue.value
        }, null, 8, ["masked", "precision", "symbol", "value"])
      ]),
      _: 1
    }, 8, ["disabled", "variant", "value", "label"]),
    (hasLockedFunds.value)
      ? (_openBlock(), _createBlock(LockedFunds, {
          key: 0,
          class: "wallet-input__locked-funds",
          currency: __props.currency.symbol,
          masked: _unref(balanceMasked),
          precision: __props.precision,
          value: lockedBalance.value,
          variant: __props.variant
        }, null, 8, ["currency", "masked", "precision", "value", "variant"]))
      : _createCommentVNode("", true)
  ]))
}
}

})